import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import * as Styles from './styles'

type Step = {
  number: number
  title: string
  desc: string
}

type Props = {
  steps: Step[]
}

export const CareerSteps = ({ steps }: Props) => {
  const { isPhone } = useMediaQueries()

  const renderSteps = (step: Step) => {
    return (
      <Styles.Step>
        <Styles.StepTitle count={step.number}>{step.title}</Styles.StepTitle>
        <Styles.StepDescription>{step.desc}</Styles.StepDescription>
      </Styles.Step>
    )
  }

  return (
    <Styles.Container>
      <Styles.StepContainer>
        {renderSteps(steps[0])}
        <Styles.VerticalLine />
        {renderSteps(steps[1])}
      </Styles.StepContainer>
      <Styles.StepContainer>
        <Styles.HorizontalLine />
        <span />
        {isPhone && Array.from({ length: 5 }).map((_, index) => <span key={index} />)}
        <Styles.HorizontalLine />
      </Styles.StepContainer>
      <Styles.StepContainer>
        {renderSteps(steps[2])}
        <Styles.VerticalLine />
        {renderSteps(steps[3])}
      </Styles.StepContainer>
    </Styles.Container>
  )
}
